import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { RouterModule } from '@angular/router';
import { CasinoLandingComponent } from './casino-landing/casino-landing.component';
import { GamesLandingComponent } from './games-landing/games-landing.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { CustomerReviewsComponent } from './customer-reviews/customer-reviews.component';
import { GamePromoBannerComponent } from './game-promo-banner/game-promo-banner.component';
import { OnBoardingStepsComponent } from './on-boarding-steps/on-boarding-steps.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { SubscribeNewslettergeComponent } from './subscribe-newsletterge/subscribe-newsletterge.component';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MusicService } from '../../Services/music.service';
import { LotteryCardsComponent } from './lottery-cards/lottery-cards.component';
import { LotteryWinnersComponent } from './lottery-winners/lottery-winners.component';
import { ShiningStarsOfGamesComponent } from './shining-stars-of-games/shining-stars-of-games.component';
import { HowItWorkComponent } from './how-it-work/how-it-work.component';
import { LandingPageService } from './landing-page.service';
import { HeroSectionComponent } from './hero-section/hero-section.component';
import { HighlightCardComponent } from './highlight-card/highlight-card.component';
import { GameService } from '../../Services/game.service';
import { PwaInstallService } from '../../Services/pwa-install.service';
import { ToastrService } from 'ngx-toastr';
import { LoginComponent } from '../login/login.component';
import { SignupComponent } from '../signup/signup.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { SideBarComponent } from '../../components/side-bar/side-bar.component';
import { SidebarService } from '../../Services/sidebar-service.service';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    CarouselModule,
    CommonModule,
    RouterModule,
    SideBarComponent,
    CasinoLandingComponent,
    GamesLandingComponent,
    AboutUsComponent,
    CustomerReviewsComponent,
    GamePromoBannerComponent,
    OnBoardingStepsComponent,
    ContactUsComponent,
    SubscribeNewslettergeComponent,
    ShiningStarsOfGamesComponent,
    HeroSectionComponent,
    FooterComponent,
    HighlightCardComponent,
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
  ],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent implements OnInit {
NavigateToHome() {
    this.router.navigate(['/']); 
  }


  private toastr = inject(ToastrService);
  public pwaInstall = inject(PwaInstallService);
  public showInstallButton: boolean = true;
  isMobile: boolean = false;
  isLandingPage: boolean = true;
  activeLotteries: any = [];
   activeSection: string = 'dashboard';
   activeFooterSection: string = 'dashboard';
  activeAuthModal: 'login' | 'signup' | 'forgot' | null = null;

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private musicService: MusicService,
    private landingPageService: LandingPageService,
    private gameService: GameService,
    private sidebarService: SidebarService
  ) {
    // this.Games = [...this.gameService.getGames(),...this.gameService?.SystemGames];
     this.Games = [...this.gameService.getGames()];
  }

  hideInstallBtn(event: Event) {
    event.stopPropagation();
    this.showInstallButton = false;
  }
  Games: any = [];
  private interactionStarted = false;
  ngOnInit(): void {
    this.isLandingPage = this.router.url === '/';

    // Observe screen size changes
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
      });

    setTimeout(() => {
      this.startMusic();
    }, 3000);

    //? Add interaction listeners
    this.addInteractionListeners();

    this.landingPageService.getActiveLotteries().subscribe((data) => {
      this.activeLotteries = data;
    });
  }

  isSticky = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const banner = document.querySelector(
      '.main-banner-container'
    ) as HTMLElement;
    if (banner) {
      const bannerHeight = banner.offsetHeight;
      this.isSticky = window.scrollY >= bannerHeight;
    }
  }

  isMobileMenuOpen = false;
  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  toggleLandingSidebar() {
    this.sidebarService.toggleSidebar();
  }

  RedirectToLogin(): void {
    this.activeAuthModal = 'login';
  }
   RedirectToRegister(): void {
    this.activeAuthModal = 'signup';
  }

  openAuthModal(type: 'login' | 'signup' | 'forgot'): void {
    this.activeAuthModal = type;
  }

  closeAuthModal(): void {
    this.activeAuthModal = null;
  }





  async installApp(): Promise<void> {
    const result = await this.pwaInstall.promptInstall();

    if (result === 'unavailable') {
      this.toastr.info(
        'To install: open your browser menu (⋮ or …) → "Install app" or "Add to Home Screen".',
        'Install Casinoze',
        { timeOut: 6000, positionClass: 'toast-top-center' }
      );
    } else if (result === 'accepted') {
      this.toastr.success('App installed successfully!', 'Casinoze', {
        timeOut: 3000,
      });
    }
  }

  scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -20;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  addInteractionListeners() {
    if (!this.interactionStarted) {
      document.addEventListener('click', this.startMusicOnce, { once: true });
      document.addEventListener('mousemove', this.startMusicOnce, {
        once: true,
      });
      document.addEventListener('keydown', this.startMusicOnce, { once: true });
      this.interactionStarted = true;
    }
  }

  startMusicOnce = () => {
    this.startMusic();
    this.removeInteractionListeners();
  };

  removeInteractionListeners() {
    document.removeEventListener('mousemove', this.startMusicOnce);
    document.removeEventListener('scroll', this.startMusicOnce);
    document.removeEventListener('click', this.startMusicOnce);
  }

  ngOnDestroy() {
    this.removeInteractionListeners();
  }

  startMusic() {
    this.musicService.playMusic();
  }

  toggleMusic() {
    this.musicService.muteUnmute();
  }

  get isMusicMuted(): boolean {
    return this.musicService.isMusicMuted();
  }

  cardList = [
    {
      id: '01',
      title: 'Rome Treasury',
      subtitle: '$116 Million Win',
      amount: '$20',
      image: '/Images/lottery.png',
      time: { hh: '03', mm: '03', ss: '03' },
    },
    {
      id: '02',
      title: 'Paris Vault',
      subtitle: '$90 Million Win',
      amount: '$15',
      image: '/Images/lottery.png',
      time: { hh: '01', mm: '15', ss: '42' },
    },
    {
      id: '03',
      title: 'London Luck',
      subtitle: '$75 Million Win',
      amount: '$10',
      image: '/Images/lottery.png',
      time: { hh: '05', mm: '45', ss: '22' },
    },
    {
      id: '04',
      title: 'Tokyo Draw',
      subtitle: '$110 Million Win',
      amount: '$25',
      image: '/Images/lottery.png',
      time: { hh: '02', mm: '25', ss: '08' },
    },
    {
      id: '05',
      title: 'Dubai Jackpot',
      subtitle: '$98 Million Win',
      amount: '$30',
      image: '/Images/lottery.png',
      time: { hh: '04', mm: '12', ss: '33' },
    },
    {
      id: '06',
      title: 'Vegas Vault',
      subtitle: '$120 Million Win',
      amount: '$40',
      image: '/Images/lottery.png',
      time: { hh: '06', mm: '05', ss: '18' },
    },
  ];
  GoToTermsAndConditions() {
    this.activeSection = 'terms';
    this.router.navigate(['/Terms&Conditions']);
  }

  GoToPrivacyPolicy() {
    this.activeSection = 'privacy';
    this.router.navigate(['/PrivacyPolicy']);
  }
}

